import React from "react";
import "./B1Page.css";

const B1CourseDetails = () => {
  return (
    <div className="b1DetailsContainer">
      <ul>
        <li>
          It is the intermediate level after which one can fluently express
          him/herself in German.
        </li>
        <li>
          It is the basic requirement for most of the Germany based
          organizations and Universities.
        </li>
        <li>
          It is an extension of A1 and A2 Levels after which one can frame
          Sentences with Advanced Grammar Structure
        </li>
      </ul>
      <h3>What to expect after completion of this course?</h3>
      <ul>
        <li>You will learn to frame complexly connected Texts</li>
        <li>This course offers Wider Range of Situations and Vocabulary.</li>
        <li>
          One learns to Use the Language in Everyday and Professional Situations
        </li>
        <li>The offers variety of interesting topics for Discussion</li>
        <li>
          One learns to Describe Experiences, Events, Dreams, Hopes and
          Ambitions
        </li>
        <li>Ability to briefly give Opinions</li>
        <li>
          Certificate is widely recognized by employers as sufficient evidence
          of Proficiency in German
        </li>
        <li>Improves the Chances of Success on Job Market</li>
      </ul>
    </div>
  );
};

export default B1CourseDetails;
